/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-25 17:15:45
 * @LastEditors: liuziwei
 * @Description: 首页领券 banner - item 组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="small-coupon-container" bindtap="clickExtra">
    <!-- 优惠价格展示 -->
    <view wx:if="{{amount}}" class="top-area">
      <text class="amount">{{ amount }}</text>
      <text wx:if="{{unit}}" class="unit">{{ unit }}</text>
    </view>
    <!-- 优惠券名称 -->
    <view class="bottom-area">
      <text wx:if="{{couponInfo.name}}" class="name">{{ couponInfo.name }}</text>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 优惠券信息
      couponInfo() {
        return this.couponData?.coupon_info ?? {}
      },
      // 优惠券金额
      amount() {
        return this.couponInfo?.displayedInfo?.amount ?? false
      },
      // 优惠券单位
      unit() {
        return this.couponInfo?.displayedInfo?.unit ?? false
      }
    },
    methods: {
      clickExtra() {
        this.triggerEvent('clickExtra', 'coupon')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .small-coupon-container
    flex 1
    display flex
    overflow hidden
    flex-direction column
    align-items center
    justify-content center
    margin-right 10px
    border-radius 8px
    background #FFECEA
    border 0.75px solid rgba(255, 0, 0, 0.3)
    position relative
    -webkit-mask radial-gradient(circle at 3.2px 62%, #0000 3.2px, red 0) -3.2px
    mask radial-gradient(circle at 3.2px 62%, #0000 3.2px, red 0) -3.2px
    &:last-child
      margin-right 0
    &::before, &::after
      content ''
      position absolute
      top 27px
      width 7px
      height 7px
      border-radius 50%
      border 0.75px solid rgba(255, 0, 0, 0.3)
    &::before
      left -4.5px
    &::after
      right -4.5px
    .top-area
      .amount, .unit
        font-weight 600
        color #FF5900
      .amount
        font-family Barlow Semi Condensed
        font-size 24px
        font-weight 400
      .unit
        font-family PingFang SC
        line-height 11px
    .bottom-area
      font-size 9px
      font-weight 400
      color #FF5900
      max-width 90%
      overflow hidden
      text-overflow ellipsis
      line-height 15px
      .name
        white-space nowrap
        font-family PingFang SC
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
